module.exports = __webpack_public_path__ + "img/likes.91658aed.png";